<waitLoading *ngIf="!isLoaded()"></waitLoading>
<ng-container *ngIf="isLoaded()">
  <div class="wrapper wrapper-content ng-scope animated fadeInRight">
    <div class="container-fluid  p-0">
      <div class="row">
        <!--
        **************************************************************************************
         DATOS
        **************************************************************************************
          -->
        <div class="col-12 p-0">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <!-- <span *ngIf="selectedDossiers">Seleccionados {{selectedDossiers.length}}</span> -->
                <span class="m-xst float-right m-l-md leyenda" *ngIf="dossiers"> {{'General.showing' | translate}} {{
                  dossiers.length }} <span *ngIf="pageInfo && pageInfo.totalElements > 0"> {{'General.from'|translate}}
                    {{ pageInfo.totalElements }}</span></span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 filterHeader" *ngIf="mostrarPanelFiltros()">
                <span *ngFor="
                        let filter of _dossierViewPrefs.filters
                          | keys: 'excludeEmptyProperties'
                      ">
                  <a *ngIf="!isEmptyFilter(filter?.value)" class="btn btn-filter btn-xs m-xs"
                    (click)="clearFilter(filter)"> {{ getFilterDesc(filter.key) }} <span *ngIf="filter.value !== true">=
                      {{ getFilterKeyValue(filter.key, filter.value) }}</span>
                    <i class="fas fa-times ml-1" aria-hidden="true"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 scroll-x">
          <p-table #dt [value]="dossiers" class="footer-over-pagination" [scrollable]="false" responsiveLayout="scroll"
            [resizableColumns]="true" [paginator]="false" [pageLinks]="5" [first]="pageInfo.number * pageInfo.size"
            [rows]="pageInfo.size" dropdownAppendTo="body" [totalRecords]="pageInfo.totalElements"
            (onPage)="reloadDossier($event)" [rowsPerPageOptions]="[10, 25, 50, 100]" [lazy]="true"
            (onSort)="customSort($event)" sortMode="multiple" [multiSortMeta]="this.primeCols" [customSort]="true"
            [(selection)]="selectedDossiers">
            <ng-template pTemplate="header">
              <tr>
                <th class="col-icon text-center" *ngIf="isMasiveEnabled ()">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>

                <th [pSortableColumn]="'contractFolderId'" [field]="'contractFolderId'" pTooltip=" {{tipoExpediente ? ('DossiersView.id.'+ tipoExpediente | translate) :('DossiersView.id.dossier' |
                translate) }}" tooltipPosition="top" style="width: 160px">
                  {{tipoExpediente ? ('DossiersView.id.'+ tipoExpediente | translate) :('DossiersView.id.dossier' |
                  translate) }} <p-sortIcon [field]="'contractFolderId'">
                  </p-sortIcon>
                </th>
                <ng-container *ngFor="let column of visibleColumns">
                  <th *ngIf="column.code!='contractFolderId'" [pSortableColumn]="column.code"
                    [ngClass]="column.type + 'TH'" pTooltip="{{ column.name }}" tooltipPosition="top"> {{ column.name }}
                    <p-sortIcon [field]="column.code">
                    </p-sortIcon>
                  </th>
                </ng-container>
                <th class="action-column text-right">
                  <button class="btn btn-secondary btn-xs " aria-expanded="false" (click)="showColumnsSelector()"
                    title="{{'DossiersView.action.cols' | translate}}">
                    <i class="fas fa-caret-left"></i>&nbsp;<i class="fa fa-columns" aria-hidden="true"></i>
                  </button>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dossier>
              <tr>
                <td class="col-icon text-center" *ngIf="isMasiveEnabled ()">
                  <p-tableCheckbox [value]="dossier"></p-tableCheckbox>
                </td>
                <td field="contractFolderId">
                  <ng-container *ngIf="!tipoExpediente.includes('CONTRACTS')">
                    <divisionDetail [division]="dossier.division" [project]="dossier" [infoLink]="true"
                      [infoTitulo]="false" class="d-inline">
                    </divisionDetail>
                  </ng-container>
                  <ng-container *ngIf="tipoExpediente.includes('CONTRACTS')">
                    <divisionDetail [division]="dossier.division" [project]="dossier.division.project" [infoLink]="true"
                      [infoTitulo]="false" [dossierType]="tipoExpediente" class="d-inline">
                    </divisionDetail>
                  </ng-container>
                </td>
                <ng-container *ngFor="let column of visibleColumns">
                  <td *ngIf="column.code!='contractFolderId'" [ngClass]="column.type + 'TH'">
                    <formatDataValue [type]="column.type" [value]="formService.getNestedProperty(dossier, column.code)">
                    </formatDataValue>
                  </td>
                </ng-container>
                <td class="text-right action-column">
                  <ng-container *ngIf="!tipoExpediente.includes('CONTRACTS')">
                    <pmenu-actions [dto]="dossier" [lazy]="true" [dtoType]="this.getDtoTypeForActions()"
                      (reload)="this.loadDossiers()" [items]="this.getDossierMenuItem(dossier)"
                      [postProcessMenuActionsFn]="updateActions.bind(this,dossier)">
                    </pmenu-actions>
                  </ng-container>
                  <ng-container *ngIf="tipoExpediente.includes('CONTRACTS')">
                    <pmenu-actions [dto]="dossier.division.project" [lazy]="true" [dtoType]="'PROJECTENTITY'"
                      (reload)="this.loadDossiers()" [items]="this.getDossierMenuItem(dossier)">
                    </pmenu-actions>
                  </ng-container>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="text-center">
                <td [attr.colspan]="visibleColumns.length + 2"> {{ 'General.noFilteredData' | translate }} </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr class="text-center">
                <td [attr.colspan]="visibleColumns.length + 2" style="padding: 0; margin: 0; border: 0">
                  <p-paginator [rows]="pageInfo.size" [first]="pageInfo.number * pageInfo.size" dropdownAppendTo="body"
                    [totalRecords]="pageInfo.totalElements" [rowsPerPageOptions]="[10, 25, 50, 100]"
                    (onPageChange)="reloadDossier($event)">
                  </p-paginator>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <!-- DATOS -->
      </div>
    </div>
  </div>
</ng-container>
<!--
    *************************************************************************************************
    ZONA DE FILTROS AVANZADOS (MODAL)
    *************************************************************************************************
  -->
<p-dialog header="{{ 'DossiersView.finder.dossier' | translate }}" [(visible)]="filtersVisible"
  (onHide)="onCloseFilters()" [responsive]="true" [modal]="true" [resizable]="false" [closable]="true"
  [dismissableMask]="true" [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'60vw'}"
  [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden'}" cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
  styleClass='searchStyle'>
  <sub-header [isModal]="true" [windowHash]=this.windowHash [includeContextHelp]="true" *ngIf="filtersVisible">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid pb-5" *ngIf="searchSettings && searchSettings.filtersSearch">
      <div class="row">
        <div class="col-12">
          <form (keyup.enter)="search()" #element>
            <ng-container tabindex="0" *ngFor="let filter of searchSettings.filtersSearch; let i = index">
              <ng-container
                *ngIf="filter.listInformationFilter.length === 1 && filter.listInformationFilter[0].type !== 'RANGE_DECIMAL'">
                <formElement [model]="_dossierViewPrefs.filters" [fieldConfig]="createFieldConfig(filter)"
                  #elementChild></formElement>
              </ng-container>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>
<p-dialog header="{{ 'DossiersView.config.title' | translate }}" [(visible)]="selectColumnsVisible"
  (onHide)="onCloseColumnSelector()" [responsive]="true" [modal]="true" [resizable]="false" [closable]="true"
  [dismissableMask]="true" [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'50vw'}"
  [contentStyle]="{ 'min-height': '50vh', 'max-height': '80vh', overflow: 'hidden'}" cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true" styleClass='searchStyle column-selector'>
  <sub-header [isModal]="true" [windowHash]=this.windowHash1 [includeContextHelp]="true" *ngIf="selectColumnsVisible">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1" *ngIf="isLoaded()">
    <div class="container-fluid">
      <div class="row ">
        <ng-container>
          <h3 class="leyenda col-12 text-center m-t-md">{{'DossiersView.colsActivas'|translate}}:</h3>
          <div class="col-12 d-flex justify-content-center m-b-lg">
            <p-pickList [source]="invisibleColumns" sourceHeader="{{'DossiersView.colsToDisplay' |translate}}"
              targetHeader="{{'DossiersView.colsSelected' |translate}}" [target]="visibleColumns" filterBy="name"
              dragdrop="true" class="col-12 ">
              <ng-template let-column pTemplate="item">
                <span>{{column.name}}</span>
              </ng-template>
            </p-pickList>
          </div>
          <!--div class="col-12">
            <button type="button" class="btn btn-sm btn-primary  col-12 text-center" (click)="clearColumns()">
              <span><i aria-hidden="true" class="mr-2 fas fa-columns fa-lg"></i>
                Establecer columnas</span>
            </button>
          </div-->
        </ng-container>
        <ng-container>
          <h3 class="leyenda col-12 text-center m-t-md">{{'DossiersView.orderCols'|translate}}:</h3>
          <div class="col-12 col-12 d-flex justify-content-center m-b-lg">
            <p-pickList [source]="noOrderColumns" [target]="orderColumns" filterBy="name" dragdrop="true"
              class="col-12 ">
              <ng-template let-column pTemplate="item">
                <span>{{column.name}}</span>
              </ng-template>
            </p-pickList>
          </div>
          <!--div class="mt-2 col-12 pt-0 pb-2 mb-2">
            <button type="button" class="btn btn-sm btn-primary  col-12 text-center" (click)="loadDossiers()">
              <span><i aria-hidden="true" class="mr-2 fas fa-sort-alpha-up fa-lg"></i>
                Ordenar</span>
            </button>
          </div-->
        </ng-container>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>